<template>
  <div class="login">
    <v-container class="pa-20 login-container" primary>
      <v-row>
        <v-col cols="12" md="4">
          <img src="../assets/logo.png" class="login__logo" alt="Logo" />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Brugernavn"
            type="text"
            outlined
            dark
            class="mb-0"
            v-model="username"
          ></v-text-field>
          <v-text-field
            label="Password"
            type="password"
            outlined
            dark
            class="mb-0"
            v-model="password"
          ></v-text-field>
          <v-text-field
            label="fname"
            type="password"
            outlined
            class="fname mb-0"
          ></v-text-field>
          <v-btn
            color="secondary"
            class="mb-5"
            block
            @click="loginUser"
            :loading="logginIn"
            >Login</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "login",
  data: () => {
    return {
      username: "",
      password: "",
      fname: "",
      error: ""
    };
  },
  computed: {
    ...mapGetters(["loginErrorMessage", "logginIn"])
  },
  methods: {
    ...mapActions(["doLogin"]),
    async loginUser() {
      if (this.username !== "" && this.password !== "" && this.fname === "") {
        const payload = {
          username: this.username,
          password: this.password
        };
        await this.doLogin(payload);
      }
    }
  }
};
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  &-container {
    height: 100%;
    display: flex;
    align-items: center;
  }

  &__logo {
    display: block;
    width: 120px;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

.fname {
  display: none;
  visibility: hidden;
}
</style>
